// tslint:disable
export var Extauth2ValidateStatus;
(function (Extauth2ValidateStatus) {
    // Password is valid
    Extauth2ValidateStatus[Extauth2ValidateStatus["Valid"] = 0] = "Valid";
    // Username is valid
    Extauth2ValidateStatus[Extauth2ValidateStatus["UserFound"] = 1] = "UserFound";
    // Password invalid
    Extauth2ValidateStatus[Extauth2ValidateStatus["Invalid"] = 2] = "Invalid";
    // Username not found
    Extauth2ValidateStatus[Extauth2ValidateStatus["UserNotFound"] = 3] = "UserNotFound";
    // Account is disabled
    Extauth2ValidateStatus[Extauth2ValidateStatus["AccountDisabled"] = 4] = "AccountDisabled";
    // Account is locked
    Extauth2ValidateStatus[Extauth2ValidateStatus["AccountLocked"] = 5] = "AccountLocked";
    // Password has expired
    Extauth2ValidateStatus[Extauth2ValidateStatus["PasswordExpired"] = 6] = "PasswordExpired";
    // An unexpected server error has occurred
    Extauth2ValidateStatus[Extauth2ValidateStatus["ServerError"] = 7] = "ServerError";
    // User must change password
    Extauth2ValidateStatus[Extauth2ValidateStatus["UserMustChangePassword"] = 8] = "UserMustChangePassword";
})(Extauth2ValidateStatus || (Extauth2ValidateStatus = {}));
Extauth2ValidateStatus['VALID'] = 0;
Extauth2ValidateStatus['USERFOUND'] = 1;
Extauth2ValidateStatus['INVALID'] = 2;
Extauth2ValidateStatus['USERNOTFOUND'] = 3;
Extauth2ValidateStatus['ACCOUNTDISABLED'] = 4;
Extauth2ValidateStatus['ACCOUNTLOCKED'] = 5;
Extauth2ValidateStatus['PASSWORDEXPIRED'] = 6;
Extauth2ValidateStatus['SERVERERROR'] = 7;
Extauth2ValidateStatus['USERMUSTCHANGEPASSWORD'] = 8;
//# sourceMappingURL=Extauth2ValidateStatus.js.map